import React, { useEffect , useState } from 'react';
import OurCommitments from './OurCommitments'
import WhoweareBanner from './WhoweareBanner'
import AboutCompany from './AboutCompany';
import AboutEnvisionBrief from './AboutEnvisionBrief';

 import OurTeamsAdd from './OurTeamsAdd';
 import OurCoPartneres from './OurCoPartneres';
 import Allcomponanatfilter from './Allcomponanatfilter';
 import Advertisment from './Advertisment';
//  import Testimonials from './Testimonials';

const WhoweAre = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Empty dependency array ensures it only runs once when the component mounts
          // Scroll to the top of the page when the component mounts
       
        
        
  return (
    <div style={{backgroundColor:"blue"}}>

         <Allcomponanatfilter/>
        

     

     

        <style>
          {`
           h1,h2,h3,h4,h5,h6,p{
         font-family: -apple-system, BlinkMacSystemFont, "SF Pro", "Segoe UI", Roboto, Helvetica, Arial, sans-serif;

          }
          `}
        </style>
    </div>
  )
}

export default WhoweAre